import { abbreviateNumber } from 'core-utilities';

export const getVotePercentage = (upvotes: number, downvotes: number): string | undefined => {
  let percentUp = 0;
  if (!Number.isNaN(upvotes) && !Number.isNaN(downvotes)) {
    if (upvotes === 0 && downvotes === 0) {
      return undefined;
    }
    if (upvotes === 0 && downvotes !== 0) {
      percentUp = 0;
    } else if (upvotes !== 0 && downvotes === 0) {
      percentUp = 100;
    } else {
      percentUp = Math.floor((upvotes / (upvotes + downvotes)) * 100);
      percentUp = percentUp > 100 ? 100 : percentUp;
    }
  }
  return `${percentUp}%`;
};

export const { getAbbreviatedValue } = abbreviateNumber;

export default {
  getVotePercentage,
  getAbbreviatedValue
};
